<template lang="html">
 	<div class="downloadList-container">
    <div class="breadCrumb-container">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>{{$t('message.app')}}</el-breadcrumb-item>
				<el-breadcrumb-item>{{$t('message.appBaic')}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

    <div class="body-container">
      <div class="table-container password-container verifone-panel">

        <!-- 只创建参数下载任务 -->
        <div v-if="parameterChange == 1 && resourecFileChange != 1">
          <div class="password-item">
            <div class="item-body">
              <span>{{$t('message.appCreateAsk')}}</span>
            </div>
          </div>
        </div>

        <!-- 只创建资源文件下载任务 -->
        <div v-if="resourecFileChange == 1 && parameterChange != 1">
          <div class="password-item">
            <div class="item-body">
              <span>{{$t('message.resourceFileTaskCreateAsk')}}</span>
            </div>
          </div>
        </div>

        <!-- 两种都创建 -->
        <div v-if="parameterChange == 1 && resourecFileChange == 1">
          <div class="password-item">
            <div class="item-body">
              <span>{{$t('message.appCreateAsk')}}</span>
            </div>
          </div>
          <div class="password-item">
            <div class="item-body radio-body">
              <el-radio-group v-model="parameterDownloadRadio">
                <el-radio :label="1">{{$t('message.yes')}}</el-radio>
                <el-radio :label="0">{{$t('message.no')}}</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="password-item">
            <div class="item-body">
              <span>{{$t('message.resourceFileTaskCreateAsk')}}</span>
            </div>
          </div>
          <div class="password-item">
            <div class="item-body radio-body">
              <el-radio-group v-model="resourceFileDownloadRadio">
                <el-radio :label="1">{{$t('message.yes')}}</el-radio>
                <el-radio :label="0">{{$t('message.no')}}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>

				<div class="password-item">
					<div class="item-body radio-body">
						<el-radio-group v-model="downloadRadio">
							<el-radio :label="0">{{$t('message.nextContact')}}</el-radio>
							<el-radio :label="1">{{$t('message.dateTime')}}</el-radio>
						</el-radio-group>
					</div>
				</div>

				<div class="password-item">
					<div class="item-body">
						<div class="date-picker-container">
							<div class="block">
								<el-date-picker :disabled="updateDisabled" v-model="downloadDate" :picker-options="pickerOptions" type="date" value-format="yyyy-MM-dd" :editable="false" :placeholder="$t('message.date')"></el-date-picker>
							</div>
						</div>
					</div>
				</div>

        <div class="submit-container">
          <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="callBack">{{$t('message.cancel')}}</el-button>
          <el-button class="verifone-btn" type="primary" icon="el-icon-document" @click="downLoadDialog">{{$t('message.submit')}}</el-button>
        </div>
      </div>
    </div>

      <!-- 是否创建下载任务 Start -->
      <el-dialog :visible.sync="submitDialogVisible" custom-class="tips-dialog" class="quit-dialog warn-dialog">
        <div class="warn-container flex-row">
          <img class="warn-icon" alt="" src="static/img/alertWarn.png">
          <span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
        </div>
        <div class="dialog-body">
         <span>{{$t('message.createTaskTipsStart')}}</span><br><div>{{modifyAppDetail}}</div> <span>{{$t('message.createTaskTipsEnd')}}</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="verifone-btn" type="primary" plain @click="callBack">{{$t('message.no')}}</el-button>
          <el-button class="verifone-btn" type="primary" @click="downLoad">{{$t('message.yes')}}</el-button>
        </span>
      </el-dialog>
      <!-- 是否创建下载任务 End -->


 	</div>
</template>

<script>
export default {
	data() {
		return {
      sn: '',
			sourceSn: '',
			downloadRadio: 0,
      parameterDownloadRadio:1,
      resourceFileDownloadRadio:1,
			downloadDate: '',
      submitDialogVisible:false,
      modifyAppDetail:'',//修改的app版本信息
      createSuccess: this.$t('message.createSuccess'),
      parameterChange: sessionStorage.getItem('parameterChange'),
      resourecFileChange: sessionStorage.getItem('resourecFileChange'),
			pickerOptions: {
        disabledDate(time){
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
			}
		}
	},
  mounted() {
    this.init();
  },
  computed: {
    updateDisabled: function() {
      return !this.downloadRadio;
    }
  },
	methods: {
    init(){
      this.modifyAppDetail =  this.$route.query.routerAppDetail;
      console.log("AAAAAAAAAAAAAAAAAAAA:"+JSON.stringify(this.$route.query.routerAppDetail))
    }
    ,
    callBack() {
      this.$router.replace('/appManagement');
    },

    downLoadDialog(){
      //跳出弹框
      this.submitDialogVisible=true;
    },
    downLoad(){
      let obj = {
        appId: sessionStorage.getItem('appId'),
        downloadType: this.downloadRadio,
        downloadDateStart: this.downloadDate
      };

      let parameterChange = this.parameterChange;
      let parameterDownloadRadio = this.parameterDownloadRadio;
      let resourecFileChange = this.resourecFileChange;
      let resourceFileDownloadRadio = this.resourceFileDownloadRadio;
      let url = '/marketplace/task/add/appParameterAndResource';
      let parameterUrl = '/marketplace/task/add/appParameter';
      let resourceUrl = '/marketplace/task/add/appResource';

      // 双任务
      if (parameterChange == 1 && resourecFileChange == 1 ){
        // 操作员只允许新增参数下载任务
        if(parameterDownloadRadio == 1 && resourceFileDownloadRadio !=1)
          url = parameterUrl;
        // 操作员只允许新增资源文件下载任务
        else if(resourceFileDownloadRadio == 1 && parameterDownloadRadio != 1)
          url = resourceUrl;
      }
      // 参数下载任务
      else if(parameterChange == 1 && resourecFileChange !=1)
        url = parameterUrl;
      // 资源文件下载任务
      else if(resourecFileChange == 1 && parameterChange != 1)
        url = resourceUrl;


      this.$axios({
        method: 'post',
        url: url,
        headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
        data: obj
      }).then(response => {
        if (response.data.resultCode != 0) {
          this.$message({
            type: "error",
            message: response.data.desc,
            duration:'3000',
          });
          return;
        }else {
          this.$message({
            type: "success",
            message: this.createSuccess,
            duration:'3000',
          });
           this.submitDialogVisible=false;
          this.$router.replace('/appManagement');
        }
      }).catch((err) => {
        console.log(err);
      });
    }
	}
}
</script>

<style lang="css" scoped="scoped">
.table-container {
	margin-top: 60px;
    padding: 12vh 10vw;
}
.password-container {
	/* display: flex;
	display: -webkit-display;
	flex-direction: column;
	justify-content: center; */
    height: 70vh;
}
.password-item {
    display: flex;
    display: -webkit-display;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    color: #666;
	/* width: 300px; */
}
.item-title, .item-body {
	width: 360px;
}
.item-title {
	font-weight: 600;
	font-weight: 19px;
}
/* .item-body {
	letter-spacing: 0.5px;
} */
.item-left {
    text-align: right;
}
.item-right {
    padding-left: 15px;
}
.required-icon {
    color: red;
    font-size: 20px;
}
.submit-container {
    margin-top: 20vh;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
}
.radio-body>div {
	display: flex;
	display: -webkit-flex;
	flex-direction: column;
}
.el-radio+.el-radio {
	margin-left: 0;
	margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/app/AppDownload.vue